var render = function render(){var _vm=this,_c=_vm._self._c;return _c('review-list',{attrs:{"boardInfo":_vm.boardInfo,"boardList":_vm.boardList,"noticeList":_vm.noticeList,"boardCount":_vm.boardCount,"size":_vm.size,"page":_vm.page},on:{"changePage":_vm.aa}})
}
var staticRenderFns = []

export { render, staticRenderFns }